import { cva } from 'class-variance-authority';
import { BeatLoader } from 'react-spinners';

const buttonVariants = cva(
  'transition-all duration-150 cursor-pointer rounded-lg capitalize focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50',
  {
    variants: {
      intent: {
        primary: [
          'bg-primary',
          'text-white',
          'hover:bg-[#046157]',
          'shadow-sm',
          'shadow-primary/50',
          'drop-shadow-sm',
          'hover:shadow-none',
        ],
        secondary: ['bg-white', 'text-primary', 'border', 'border-dashed', 'border-primary', 'hover:bg-primary/5'],
        underline: ['underline', 'text-primary'],
      },
      size: {
        small: ['text-body', 'py-1', 'px-2'],
        medium: ['text-base', 'py-2', 'px-4'],
        large: ['text-lg', 'py-3', 'px-6'],
      },
      state: {
        active: [],
        disabled: ['opacity-50', 'cursor-not-allowed', 'shadow-none', 'drop-shadow-none', 'pointer-events-none'],
        loading: ['opacity-50', 'cursor-not-allowed', 'shadow-none', 'drop-shadow-none', 'pointer-events-none'],
      },
    },
    defaultVariants: {
      intent: 'primary',
      size: 'medium',
      state: 'active',
    },
  },
);

export const Button = ({ className, intent, size, disabled = false, isLoading = false, children, ...props }) => {
  const computedState = isLoading ? 'loading' : disabled ? 'disabled' : 'active';

  return (
    <button
      className={buttonVariants({ intent, size, state: computedState, className })}
      disabled={disabled || isLoading}
      aria-disabled={disabled || isLoading}
      aria-busy={isLoading}
      {...props}
    >
      {isLoading ? (
        <span className="flex items-center justify-center gap-2">
          {children}
          <BeatLoader size={8} color={intent === 'secondary' ? '#058A7C' : '#ffffff'} />
        </span>
      ) : (
        children
      )}
    </button>
  );
};
